<template>
  <bottom-sheet variant="primary" @close="closeMenu">
    <template v-slot:header>
      <div class="document-info-header">
        <div class="info-row">
          <span class="ri-small-body white-text">העלאת המסמך ב-{{ uploadDate }}</span>
        </div>
        <div class="info-row verification-row">
          <icon
            :icon-name="verificationIcon"
            :size="'18px'"
            :color="verificationColor"
            class="verification-icon"
          />
          <span class="ri-small-body" :style="{ color: verificationColor }">
            {{ verificationText }}
          </span>
        </div>
        <div v-if="verificationNotes" class="info-row">
          <span class="ri-small-body" :style="{ color: verificationColor }">{{ verificationNotes }}</span>
        </div>
      </div>
    </template>
    <template v-slot:menuItems>
      <bottom-sheet-menu-item
        v-for="menuItem in menuItems"
        :key="menuItem.text"
        :text="menuItem.text"
        :icon-props="menuItem.iconProps"
        @click="() => onItemClick(menuItem)"
      />
    </template>
  </bottom-sheet>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'DocumentMenu',
  components: {
    BottomSheet: BaseUI.BottomSheet,
    BottomSheetMenuItem: BaseUI.BottomSheetMenuItem,
    Icon: BaseUI.Icon,
  },
  props: {
    menuItems: {
      type: Array,
      required: false,
      default: () => [],
    },
    uploadDate: {
      type: String,
      required: false,
      default: '',
    },
    verificationIcon: {
      type: String,
      required: false,
      default: 'info',
    },
    verificationColor: {
      type: String,
      required: false,
      default: '#000000',
    },
    verificationText: {
      type: String,
      required: false,
      default: '',
    },
    verificationNotes: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    closeMenu() {
      this.$emit('close');
    },
    onItemClick(item) {
      this.closeMenu();
      if (item.onClick) {
        item.onClick();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.document-info-header {
  padding-top: $ri-spacing-xs;

  .info-row {
    margin-bottom: $ri-spacing-xs;
    text-align: right;

    &:last-child {
      margin-bottom: 0;
    }

    &.verification-row {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      justify-content: flex-end;
    }
  }

  .verification-icon {
    margin-left: $ri-spacing-xxs;
  }

  .white-text {
    color: $riseup_white;
  }
}
</style>
